module.exports = __webpack_public_path__ + "img/7.abfeeb5c.png";